// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SorterSmallIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SorterSmallIcon" ref={forwardedRef} {...props}>
      <path d="m6.5 9 3.5 3.5L13.5 9z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SorterSmallIcon = /* @__PURE__ */ Object.assign(
  SorterSmallIconComponent,
  { displayName: 'SorterSmallIcon' },
);
